import { AnyAction, PayloadAction, createAction } from '@reduxjs/toolkit';

import type { AnyApi } from '../../buildCreateApi';

/**
 * Формат мета-информации в экшенах {reducerPath}/executeQuery/rejected.
 * Экшен создается внутри RTK Query, но не экспортируется.
 */
export type QueryRejectedAction = PayloadAction<
    unknown,
    string,
    {
        condition: boolean;
        requestId: string;
        arg: {
            queryCacheKey: string;
        };
    },
    unknown
>;

/**
 * Создает функцию-матчер, которая определяет является ли экшен реджетом запроса.
 * @param api Инстанс RTK Query API.
 * @returns Функция-матчер, которая определяет является ли экшен реджектом запроса.
 */
export function createQueryRejectedActionMatcher<Api extends AnyApi>(api: Api) {
    const queryRejectedAction = createAction(`${api.reducerPath}/executeQuery/rejected`);

    return function match(action: AnyAction): action is QueryRejectedAction {
        return queryRejectedAction.match(action);
    };
}
